import { Icon } from "@mui/material";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { StyledText } from "../../components/Text";
import theme from "../../styles/theme";
import styled, { keyframes } from "styled-components";
// import { motion } from "framer-motion";

interface Competency {
  template_pillar_id: string;
  pillar_title: string;
  id: string;
  title: string;
  competency_code: string;
  description: string;
  subdomain_title: string;
  required: boolean;
  credits: any;
  status_val: any;
  status: any;
  mastery_level: any;
  mastery_level_title: any;
  transferred: any;
  earned: any;
  curriculum_version: any;
  total_skills: any;
  assessed_skills: any;
  skills: any;
  card_history_events: any;
  affect_gpa: any;
  semester_name: any;
  university_code: any;
  graphics: any;
}
interface Cards {
  competencies: Competency[];
  pillar_title: string;
  template_pillar_id: string;
}
interface Props {
  data: Cards[];
  setSelectedPillar: (x: boolean) => void;
}
type BlockProps = {
  backgroundColor: string;
};
const CustomAssessmentBlock = styled(FlexGrow)<BlockProps>`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  text-align: center;
  border-radius: 12px;
  // border-radius: 12px;
  background: ${({ backgroundColor }) => backgroundColor};
  box-shadow: black 0px 1px 4px 0px;
  padding: 16px;
  flex-grow: 0;
  cursor: pointer;
  width: 171px;
  min-width: 171px;
  max-width: 171px;
  height: 270px;
  min-height: 270px;
  max-height: 270px;
  overflow: hidden;
`;
const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(1.1); }
`;
const PendingBadge = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #b45309, #d97706);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: white;
  z-index: 10;
  animation: ${pulse} 2s ease-in-out infinite;
  box-shadow: 0 0 8px rgba(217, 119, 6, 0.8);
  border: 2px solid rgba(255,255,255,0.3);
`;
export const PillarList = (props: Props) => {
  const { data, setSelectedPillar } = props;
  return (
    <FlexBox
      alignItems="flex-start"
      style={{
        marginBottom: theme.spacing.x2,
      }}
    >
      {data.map((d: any) => (
        // <motion.div whileHover={{ scale: 0.98 }} whileTap={{ scale: 1.05 }}>
        <FlexBox
            direction="column"
            space={0}
            style={{
              marginBottom: "13px",
              position: "relative",
            }}
          >
            {d.competencies.some((c: any) => c.instructor_approved === false && (c.status === "In progress" || c.status === "Selected" || c.status === "Completed")) && (
              <PendingBadge title="Pending AO Approval">⏳</PendingBadge>
            )}
            <CustomAssessmentBlock
              backgroundColor={d.competencies[0]?.graphics?.iconbg || "#23273e"}
              onClick={() => {
                setSelectedPillar(d);
              }}
            >
              {/* <StyledImg
                src={
                  d.competencies[0].graphics?.imgurl
                    ? process.env.REACT_APP_IMG_URL +
                      d.competencies[0].graphics?.imgurl
                    : ""
                }
                alt=""
              /> */}

              <Icon
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  color: "white",
                  paddingY: "6px",
                  background: d.competencies[0]?.graphics?.iconbg || "#23273e",
                  borderRadius: "6px",
                  fontSize: "50px",
                  boxShadow: "inset 0 0px 10px #0000003d",
                  width: "100%",
                  height: "auto",
                  border: "2px solid rgb(255, 255, 255)",
                  // marginBottom: 5,
                }}
              >
                {d.competencies[0]?.graphics?.icon || "help"}
                <span
                  style={{
                    fontWeight: "bold",
                    maxWidth: 150,
                    overflow: "hidden", // Prevent content from flowing outside the bounds
                    whiteSpace: "normal", // Enable text wrapping
                    wordBreak: "break-word", // Ensure long words wrap properly
                    textAlign: "center", // Optional: Center the text
                  }}
                >
                  {d.pillar_title}
                </span>
              </Icon>
            </CustomAssessmentBlock>
          </FlexBox>
        // </motion.div>
      ))}
    </FlexBox>
  );
};
